window.dataLayer = window.dataLayer || [];
function gtag() {
	dataLayer.push(arguments);
}
if (localStorage.getItem("consentMode") === null || parseInt(localStorage.getItem("consentModeExpiry"), 10) < Date.now()) {
	localStorage.removeItem("consentMode");
	gtag("consent", "default", {
		ad_storage: "denied",
		analytics_storage: "denied",
		personalization_storage: "denied",
		functionality_storage: "granted",
		security_storage: "granted",
	});
} else {
	gtag("consent", "default", JSON.parse(localStorage.getItem("consentMode")));
}
